
import {Injectable} from '@angular/core'
import {Http, Response} from '@angular/http'
import { IConfiguration } from '../model/Configuration';
import { HttpUtility } from './HttpUtility';

@Injectable()
export abstract class ConfigurationReaderBase{
    constructor(protected http: Http){}
    abstract Configuration:IConfiguration;
    abstract loadConfig();    
}

@Injectable()
export class ConfigurationReader extends ConfigurationReaderBase {
    constructor(protected http: Http, protected httpUtility: HttpUtility){
        super(http);            
    }
    Configuration:IConfiguration;   

    loadConfig(){
        return new Promise((resolve, reject) => {
            this.http.get(`../assets/configuration/app.json?d=${new Date().toISOString().substr(0, 13)}`)
            .map ((res: Response) => <IConfiguration>res.json())
            .catch(this.httpUtility.handleError)
            .subscribe(r=>{
                this.Configuration = r;
                resolve(true);
            });
        });
    }
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Shared/service/ConfigurationReader.ts